export default __webpack_public_path__ + "2339b027d0939df98ee80708cc2958c8.png";